export default "__VITE_ASSET__7902c5ea__"